(function initArticleCarousels() {
  const carouselWrappers = document.querySelectorAll('.article-carousel-wrapper');
  if (!carouselWrappers.length) return;

  const INDICATOR_ACTIVE = 'bg-white';
  const INDICATOR_INACTIVE = 'bg-transparent';
  const DRAG_THRESHOLD = 5;
  let drag = null;
  let lastDraggedContainer = null;

  document.addEventListener(
    'mousemove',
    (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) drag.hasDragged = true;
      drag.container.scrollLeft = drag.startScrollLeft - dx;
    },
    { passive: true }
  );

  document.addEventListener('mouseup', () => {
    if (!drag) return;
    drag.container.style.cursor = 'grab';
    drag.container.style.scrollSnapType = '';
    drag.container.style.scrollBehavior = '';
    lastDraggedContainer = drag.hasDragged ? drag.container : null;
    drag = null;
  });

  const initDragScroll = (container) => {
    if (!container) return;

    container.style.cursor = 'grab';

    container.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      drag = { container, startX: e.clientX, startScrollLeft: container.scrollLeft, hasDragged: false };
      container.style.cursor = 'grabbing';
      container.style.scrollSnapType = 'none';
      container.style.scrollBehavior = 'auto';
      e.preventDefault();
    });

    container.addEventListener(
      'click',
      (e) => {
        if (lastDraggedContainer === container) {
          e.stopPropagation();
          e.preventDefault();
          lastDraggedContainer = null;
        }
      },
      true
    );

    container.addEventListener('dragstart', (e) => e.preventDefault());
  };

  carouselWrappers.forEach((carouselWrapper) => {
    const carousel = carouselWrapper.querySelector('.carousel');
    if (!carousel) return;

    const indicators = carouselWrapper.querySelector('.carousel-indicators');
    const prevBtn = carouselWrapper.querySelector('.carousel-arrow-prev');
    const nextBtn = carouselWrapper.querySelector('.carousel-arrow-next');
    const slides = carousel.children;
    const total = slides.length;

    let activeIndex = 0;

    const scrollToIndex = (index) => {
      const slide = slides[index];
      if (slide) carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };

    const updateArrows = (index) => {
      prevBtn?.classList.toggle('hidden', index === 0);
      nextBtn?.classList.toggle('hidden', index === total - 1);
    };

    const updateActive = (index) => {
      if (indicators) {
        indicators.children[activeIndex]?.classList.replace(INDICATOR_ACTIVE, INDICATOR_INACTIVE);
        indicators.children[index]?.classList.replace(INDICATOR_INACTIVE, INDICATOR_ACTIVE);
      }
      updateArrows(index);
      activeIndex = index;
    };

    updateArrows(0);
    initDragScroll(carousel);

    carouselWrapper.addEventListener('click', (e) => {
      const slideBtn = e.target.closest('button[data-slide]');
      if (slideBtn && indicators?.contains(slideBtn)) {
        e.stopPropagation();
        e.preventDefault();
        scrollToIndex(Number(slideBtn.dataset.slide) - 1);
        return;
      }

      if (e.target.closest('.carousel-arrow-prev')) {
        e.stopPropagation();
        e.preventDefault();
        scrollToIndex(Math.max(0, activeIndex - 1));
        return;
      }

      if (e.target.closest('.carousel-arrow-next')) {
        e.stopPropagation();
        e.preventDefault();
        scrollToIndex(Math.min(total - 1, activeIndex + 1));
        return;
      }
    });

    let userScrolled = false;

    carousel.addEventListener('scroll', () => { userScrolled = true; }, { once: true });

    const observer = new IntersectionObserver(
      (entries) => {
        if (!userScrolled) return;
        const entry = entries.reduce(
          (best, e) =>
            e.isIntersecting && e.intersectionRatio > (best?.intersectionRatio ?? 0) ? e : best,
          null
        );
        if (!entry) return;
        const index = Number(entry.target.dataset.index);
        if (index === activeIndex) return;
        updateActive(index);
      },
      { root: carousel, threshold: 0.6 }
    );

    for (let i = 0; i < total; i++) {
      slides[i].dataset.index = String(i);
      observer.observe(slides[i]);
    }
  });
})();
